import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Building2, User } from "lucide-react";

export function RegisterForm({ role, setRole, regData, setRegData, busy, onSubmit }) {
  return (
    <>
      <div className="grid grid-cols-2 gap-2 mb-4">
        <button type="button" data-testid="role-tenant" onClick={() => setRole("tenant")}
          className={`flex items-center gap-2 p-3 rounded-sm border text-sm font-semibold ${role === "tenant" ? "border-primary bg-primary/5 text-primary" : "border-border"}`}>
          <User className="w-4 h-4" /> Tenant
        </button>
        <button type="button" data-testid="role-landlord" onClick={() => setRole("landlord")}
          className={`flex items-center gap-2 p-3 rounded-sm border text-sm font-semibold ${role === "landlord" ? "border-primary bg-primary/5 text-primary" : "border-border"}`}>
          <Building2 className="w-4 h-4" /> Landlord
        </button>
      </div>
      <form onSubmit={onSubmit} className="space-y-4">
        <div><Label>Full name</Label><Input data-testid="reg-name" required value={regData.name} onChange={(e) => setRegData({ ...regData, name: e.target.value })} /></div>
        <div><Label>Email</Label><Input data-testid="reg-email" type="email" required value={regData.email} onChange={(e) => setRegData({ ...regData, email: e.target.value })} /></div>
        <div><Label>Password</Label><Input data-testid="reg-password" type="password" required value={regData.password} onChange={(e) => setRegData({ ...regData, password: e.target.value })} /></div>
        <Button type="submit" className="w-full" disabled={busy} data-testid="reg-submit">{busy ? "Creating…" : `Create ${role} account`}</Button>
      </form>
    </>
  );
}
